import type {PlantUpmId} from '@hconnect/upm'
import upmPlantsWhiteList from '@hconnect/upm/src/modules/plants/upmPlantsWhiteList.json'

import plannerContactPersonImageSrc from '../assets/ContactPersonImage/planner.jpeg'
import {PLANT_ID} from '../consts'
import type {AppConfig} from '../types'

const whiteListedPlants: PlantUpmId[] = Object.keys(upmPlantsWhiteList)

export const planner: AppConfig = {
  contact: {
    name: 'Daniil Starikov',
    mail: 'daniil.starikov@heidelbergmaterials.com',
    profileImage: plannerContactPersonImageSrc
  },
  name: 'Planner',
  url: {
    qa: `https://planner-qa.hproduce.digital/plants/${PLANT_ID}`,
    uat: `https://planner-uat.hproduce.digital/plants/${PLANT_ID}`,
    prod: `https://planner.hproduce.digital/plants/${PLANT_ID}`
  },
  whiteListedPermissionTypes: ['VIEW_ELECTRICITY_PRICE'],
  plant: {
    whiteList: whiteListedPlants
  }
}
